import { Form, TimePicker } from 'antd';
import React, { useEffect } from 'react';
import dayjs from "dayjs";


const Time = ({
    name,
    label,
    defaultValue,
    labelCol,
    form,
    width,
    required,
    errorMessage,
    validateFunction,
    placeholder,
    disabled
}) => {

    useEffect(() => {
        if (defaultValue && form) {
            form.setFieldsValue({ [name]: dayjs(defaultValue, 'HH:mm:ss') })
        }
    }, [defaultValue]);

    return (
        <Form.Item
            name={name}
            label={label}
            labelCol={{ span: labelCol ? labelCol : 8 }}
            // initialValue={value}
            initialValue={(defaultValue && !form) ? dayjs(defaultValue) : null}
            style={{ width: width, fontWeight: 600 }}
            rules={[
                {
                    required: required,
                    message: errorMessage,
                },
                () => ({
                    validator(rule, value) {
                        return validateFunction
                            ? validateFunction(rule, value)
                            : Promise.resolve();
                    },
                }),
            ]}
        >
            <TimePicker style={{minHeight: 40}} disabled={disabled} placeholder={placeholder} format={'HH:mm:ss'}
            />
        </Form.Item>
    );
}

export default Time;